var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSwitcher(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/switcher"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2202 1.19326C14.9511 0.935581 14.5147 0.935581 14.2455 1.19326C13.9764 1.45094 13.9764 1.86871 14.2455 2.12639L18.647 6.34024H4.6892C4.30857 6.34024 4 6.63565 4 7.00006C4 7.36447 4.30857 7.65988 4.6892 7.65988H18.6469L14.2455 11.8736C13.9764 12.1313 13.9764 12.5491 14.2455 12.8067C14.5147 13.0644 14.9511 13.0644 15.2202 12.8067L20.7981 7.46657C20.9274 7.34283 21 7.175 21 7C21 6.825 20.9274 6.65718 20.7981 6.53343L15.2202 1.19326Z",
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.77979 11.1933C9.04894 10.9356 9.48532 10.9356 9.75447 11.1933C10.0236 11.4509 10.0236 11.8687 9.75447 12.1264L5.35302 16.3402H19.3108C19.6914 16.3402 20 16.6356 20 17.0001C20 17.3645 19.6914 17.6599 19.3108 17.6599H5.35314L9.75447 21.8736C10.0236 22.1313 10.0236 22.5491 9.75447 22.8067C9.48532 23.0644 9.04894 23.0644 8.77979 22.8067L3.20186 17.4666C3.07261 17.3428 3 17.175 3 17C3 16.825 3.07261 16.6572 3.20186 16.5334L8.77979 11.1933Z",
    fill: "#282828"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitcher);
export default __webpack_public_path__ + "static/media/switcher.04b5a77d227da418b21febbf97677bbd.svg";
export { ForwardRef as ReactComponent };